import { createApi } from '@reduxjs/toolkit/query/react';

import { settings } from '@/_config';

import baseQueryWithReAuth from '../helper/base-query-with-auth';

const unAuthCustomerApis = createApi({
  reducerPath: 'unAuthCustomerApis',
  baseQuery: baseQueryWithReAuth({ baseUrl: settings.baseURL[0], appName: 'ATP', authRequired: false }),
  tagTypes: [],
  endpoints: () => ({}),
});

export default unAuthCustomerApis;
